import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import {register} from 'swiper/element/bundle';


import { DirectivesModules } from "../shared/directives/directives.module";
import { ComponentsModule } from '../shared/components/components.module';

import { MovieCollectRoutingModule } from './movie-collect-routing.module';

import { MovieCollectComponent } from './movie-collect.component';

register(); // register swiper@9



@NgModule({
  declarations: [
    MovieCollectComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    DirectivesModules,
    ComponentsModule,
    MovieCollectRoutingModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class MovieCollectModule { }
